var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{style:({ marginTop: '2em' }),attrs:{"editable":false}},[_c('nav',{staticClass:"panel"},_vm._l((_vm.orderedDepots),function(depot){return _c('depot',{key:depot.id,attrs:{"depot":depot}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }